<template>
  <div class="categories">
    <div ref="categoriesList" class="categories-list">
      <div v-for="(categories, groupIndex) in mainCategories" :key="groupIndex" class="group">
        <div v-for="(category, index) in categories" :key="index">
          <div
            v-if="category.id !== '643'"
            class="category flex"
            @click.stop="getChildren(category, index)"
          >
            <div class="flex items-center justify-between">
              <router-link
                :to="mainCategoryRoute(category)"
                class="label w-full"
                :class="{ 'font-medium text-blue-600': isActiveCategory(category.id) }"
                @click.prevent="onClickCategory(category.id)"
              >
                <span class="flex items-center gap-2">
                  <OurSvgIcon
                    v-if="
                      category.id === 'promotional-offers' ||
                      category.id === '643' ||
                      category.id === 'wholesale'
                    "
                    :src="srcIcon(category.id)"
                    size="sm"
                    class="relative z-10"
                  />
                  {{ category.description }}
                </span>
              </router-link>
              <OurSvgIcon
                v-if="category.children.length"
                :src="icons.AngleRight"
                size="sm"
                color="gray"
                class="relative z-10"
                :class="{ 'rotate-90': subcategoryShowed === index }"
              />
            </div>
          </div>
          <div v-if="subcategoryShowed === index" class="flex flex-col">
            <div v-for="el of subCats" :key="el.id" class="sub-category flex flex-col">
              <div class="category-child flex items-center justify-between">
                <router-link
                  :to="{ name: $route.name, query: { category: el.id } }"
                  class="relative z-10 block w-100"
                  :class="{ 'font-medium text-blue-600': isActiveCategory(el.id) }"
                  @click.prevent.stop="onClickCategory(el.id)"
                >
                  {{ el.description }}
                </router-link>
                <OurSvgIcon
                  v-if="el.children.length"
                  :src="icons.AngleRight"
                  size="sm"
                  color="gray"
                  class="relative z-10"
                  :class="{ 'rotate-90': activeSubcategory === el.id }"
                  @click.stop="toggleSubcategory(el.id)"
                />
              </div>
              <ul
                v-if="activeSubcategory === el.id && getChildCategories(el).length"
                class="subcategory"
              >
                <NestedCategoryItem
                  v-for="child in getChildCategories(el)"
                  :key="child.id"
                  :category="child"
                  :items="items"
                  :active-category-id="activeCategoryId"
                  @select="onClickSubCategory"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NestedCategoryItem from "./NestedCategoryItem.vue";

export default {
  name: "CategoriesList",

  components: {
    NestedCategoryItem,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      activeSubcategory: null,
      subcategoryShowed: null,
      subCats: [],
      parentHeight: null,
      parentWidth: null,
      baseFontSize: 16,
      subGroupIndex: 1,
      activeArrow: null,
      list: null,
    };
  },

  computed: {
    icons: () => ({
      AngleRight: require("@/components/_bit/IconSvg/icons/Angle-right.svg"),
      LocalMall: require("@material-symbols/svg-400/outlined/local_mall-fill.svg"),
      PromoIcon: require("@material-symbols/svg-400/outlined/loyalty-fill.svg"),
      WholesaleIcon: require("@material-symbols/svg-400/outlined/storefront-fill.svg"),
    }),

    mainCategories() {
      return [this.items.filter(({ parent }) => parent === null)];
    },

    activeCategoryId() {
      return this.$route.query.category || null;
    },
  },

  watch: {
    "$route.query.category"(newVal, oldVal) {
      this.syncActiveCategory(newVal);

      if (newVal !== oldVal && newVal) {
        this.onClickCategory(newVal);
      }
    },

    items() {
      this.syncActiveCategory(this.activeCategoryId);
    },
  },

  created() {
    this.syncActiveCategory(this.activeCategoryId);

    if (this.activeCategoryId) {
      this.onClickCategory(this.activeCategoryId);
    }
  },

  mounted() {
    this.list = document.getElementById("list");
  },

  methods: {
    srcIcon(id) {
      if (id === "promotional-offers") {
        return this.icons.PromoIcon;
      }

      if (id === "wholesale") {
        return this.icons.WholesaleIcon;
      }

      if (id === "643") {
        return this.icons.LocalMall;
      }
    },

    mainCategoryRoute(category) {
      const isProductsOrDashboard =
        this.$route.name === "Products" || this.$route.name === "Dashboard";

      if (category.id === "643") {
        return "/flea-market";
      }

      if (category.id === "promotional-offers") {
        const targetName = isProductsOrDashboard ? "Products" : this.$route.name;

        return { name: targetName, query: { has_promotion: 1 } };
      }

      if (category.id === "wholesale") {
        const targetName = isProductsOrDashboard ? "Products" : this.$route.name;

        return { name: targetName, query: { has_wholesale_prices: 1 } };
      }

      if (!isProductsOrDashboard) {
        return { name: this.$route.name, query: { category: category.id } };
      }

      return `/products?category=${category.id}`;
    },

    getChildren(category, index) {
      if (category.id === "643") {
        this.$router.push("/flea-market");

        return;
      }

      this.activeSubcategory = null;

      if (this.subcategoryShowed !== index) {
        this.subCats = category.children.map((id) => {
          return this.items.find((item) => item.id === id);
        });
        this.subcategoryShowed = index;
      } else {
        this.subcategoryShowed = null;
      }
    },

    getChildCategories(category) {
      if (!category?.children?.length) {
        return [];
      }

      return category.children
        .map((id) => this.items.find((item) => item.id === id))
        .filter((item) => item && (item.parent === category.id || item.parentId === category.id));
    },

    toggleSubcategory(id) {
      this.activeSubcategory = this.activeSubcategory === id ? null : id;
    },

    onClickCategory(id) {
      if (id) {
        const selected = this.items.find((item) => item.id === id);

        this.$emit("clickCategory", selected);
      }
    },

    onClickSubCategory(id) {
      if (this.$route.name !== "Dashboard" && this.$route.name !== "Products") {
        this.$router.push({ name: this.$route.name, query: { category: id } });
      } else {
        if (this.$route.query.category !== id) {
          this.$router.push({ name: "Products", query: { category: id } });
        }
      }
    },

    findCategory(id) {
      if (!id) {
        return null;
      }

      return this.items.find((item) => String(item.id) === String(id)) || null;
    },

    getParentId(category) {
      if (!category?.parent && category?.parent !== 0) {
        return category?.parentId ?? null;
      }

      if (category.parent === null) {
        return null;
      }

      if (typeof category.parent === "object") {
        return category.parent.id ?? null;
      }

      return category.parentId ?? category.parent ?? null;
    },

    getCategoryPath(categoryId) {
      const path = [];
      let current = this.findCategory(categoryId);

      while (current) {
        path.unshift(current);
        const parentId = this.getParentId(current);

        current = parentId ? this.findCategory(parentId) : null;
      }

      return path;
    },

    isActiveCategory(id) {
      return this.activeCategoryId && String(id) === String(this.activeCategoryId);
    },

    syncActiveCategory(categoryId) {
      if (!categoryId) {
        this.subcategoryShowed = null;
        this.subCats = [];
        this.activeSubcategory = null;

        return;
      }

      if (!this.items.length) {
        return;
      }

      const path = this.getCategoryPath(categoryId);

      if (!path.length) {
        return;
      }

      if (path.length === 1) {
        this.subcategoryShowed = null;
        this.subCats = [];
        this.activeSubcategory = null;

        return;
      }

      const rootCategory = path[0];
      const mainCategoriesList = this.mainCategories[0] || [];
      const mainIndex = mainCategoriesList.findIndex(
        (category) => String(category.id) === String(rootCategory.id)
      );

      if (mainIndex === -1) {
        return;
      }

      this.subCats = (rootCategory.children || [])
        .map((id) => this.findCategory(id))
        .filter(Boolean);
      this.subcategoryShowed = mainIndex;
      this.activeSubcategory = path.length > 2 ? path[1].id : null;
    },
  },
};
</script>

<style lang="postcss" scoped>
.categories-list {
  @apply flex;
  @apply h-fit max-h-full;
  @apply relative;
  .group {
    @apply divide-gray-100 hover:bg-white;
    @apply h-full w-full;
    & div {
      @apply w-full cursor-pointer;
    }
    .category {
      @apply relative flex items-center justify-between;
      @apply cursor-pointer;
      @apply rounded-lg;
      @apply w-full space-x-5 py-3;
      &:hover {
        &:after {
          content: "";
          position: absolute;
          left: -2%;
          top: 0;
          height: 100%;
          width: 104%;
          display: block;
          z-index: 0;
          @apply rounded-lg bg-gray-900 bg-opacity-5;
        }
      }
      &-child {
        @apply relative p-2 text-sm;
        &:hover {
          &:after {
            content: "";
            position: absolute;
            left: -2%;
            top: 0;
            height: 100%;
            width: 104%;
            display: block;
            z-index: 0;
            @apply rounded-lg bg-gray-900 bg-opacity-5;
          }
        }
      }
      .label {
        @apply relative z-10 text-sm font-medium;
      }
    }
  }
}

.categories-list .group .category {
  align-items: flex-start !important;
  & > :not([hidden]) ~ :not([hidden]) {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
</style>

<style lang="postcss">
.subcategory {
  @apply px-3 py-2 text-xs;
  li {
    @apply py-2;
    .nested-category-item {
      display: grid;
      grid-template-columns: 5fr 1fr;
      align-items: center;
    }
    .nested-category-label {
      @apply cursor-pointer;
    }
    .nested-category-arrow {
      @apply ml-5 justify-self-end;
      filter: contrast(0.1);
    }
  }
}
</style>
